import React from 'react';

const NotificationsHeader: React.FC = () => {
  return (
    <div className="sticky top-0 z-10 bg-light-surfacePrimary dark:bg-tertiary-dark">
      <div className="mx-auto px-4 pt-8 sm:px-6 lg:px-8">
        <div className="border-b border-gray-200 dark:border-gray-700 pb-2">
          <div className="flex items-center gap-4 mb-4">
            <div>
              <h1 className="text-xl font-bold text-gray-900 dark:text-white font-['Inter']">
                Notifications
              </h1>
              <p className="text-sm font-semibold text-gray-500 dark:text-gray-400 font-['Inter'] mt-1">
                Configure automated Slack notifications for your workspace
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsHeader;